module.exports = __webpack_public_path__ + "img/outlander2022_out.d9a2586d.jpg";